import { render, staticRenderFns } from "./MagazzinoListiniEditModalComponent.vue?vue&type=template&id=d9f12448"
import script from "./MagazzinoListiniEditModalComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoListiniEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports